/**
 * Draw text or boxes debug mode.
 */
export enum EDebugPipeVisualization {
  DPV_None,
  DPV_Text,
  DPV_Pressure,
  DPV_PressureGroup,
  DPV_DeltaPressure,
  DPV_Flow,
  DPV_MoveToOverfillRatio,
}
